import { Template } from './template';

export class UpdateTemplate extends Template{
    constructor() {
       super();
    }
}
